import React from "react";
import LearningHero from "../components/app/learning/LearningHero";
import Social, { ISocials } from "../components/app/common/Socials";
import EarlyAccess from "../components/app/common/EarlyAccess";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import FeaturesBento from "../components/app/learning/FeaturesBento";
import WhyChoose from "../components/app/learning/WhyChoose";
import MeetTeam, { ITeamMember } from "../components/app/common/MeetTeam";
import { BlurFade } from "../components/app/BlurFade";
import LearningTestimonials from "../components/app/learning/LearningTestimonial";

const LearningPage: React.FC = () => {
  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];

  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dream.lms?igsh=NTgyd3dldHdhZmli",
    },
  ];

  const teamMembers: ITeamMember[] = [
    {
      name: "Ajay Kumar",
      role: "Project Manager",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/images/ajay-kumar.png",
    },
    {
      name: "Alok",
      role: "Software Engineer",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/learning/meet/alok.png",
    },
    {
      name: "Ranjit",
      role: "Operations Manager",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/images/ranjit-singh.png",
    },
    {
      name: "Kulwinder Singh",
      role: "Server & Network Admin",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/learning/meet/kulwinder.png",
    },
  ];
  const leftMember = {
    name: "Harish Ratnani",
    role: "Director",
    description:
      "There are many variations of passages of Lorem Ipsum available",
    linkedin: "http://linkedin.com/in/harish-ratnani-78013515",
    image: "/learning/meet/meet-1.png",
  };
  return (
    <div>
      <section
        className="p-5 sm:p-7 lg:p-10"
        style={{
          backgroundImage: "url(/skill/landing-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <LearningHero />
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 flex flex-col lg:flex-row mt-[8rem] md:mt-[13rem] xl:mt-[22rem] sm:px-10 md:px-24">
          <div className="flex flex-1 flex-col p-3 md:mb-10 lg:mb-0 md:flex-row gap-5 sm:gap-10 lg:pl-[4.8rem] items-center">
            <div className="flex justify-center items-center mb-8 md:mb-0 lg:mb-0 lg:b-0">
              <div className="text-3xl sm:text-4xl lg:text-5xl max-w-[22rem] h-full flex flex-col justify-between ">
                <h3 className="leading-tight">
                  Your All-in-One Corporate Training Solution
                </h3>
                <p className="text-xs pt-3 lg:text-sm xl:text-[0.89rem]">
                  Dream LMS is designed for organizations ready to revolutionize
                  their employee training processes. From skill-building to
                  compliance, we simplify learning with cutting-edge technology,
                  user-friendly interfaces, and robust reporting tools.
                </p>
              </div>
            </div>
          </div>
          <div className="flex xl:justify-center justify-center xl:flex-1">
            <div className="flex flex-col justify-between gap-5">
              <div className="flex flex-col h-full">
                <h4 className="text-[#FF7E00] font-bold lg:text-lg xl:text-xl pb-3">
                  What Makes Dream LMS Unique?
                </h4>
                <div className="space-y-5">
                  <div className="pl-5 py-2 lg:py-4  flex flex-col justify-center rounded-l-full text-[#10124E] bg-gradient-to-r from-[#B5E0FA] to-[#CEEEE900] to-40%">
                    <div className="lg:text-lg xl:text-xl">
                      Anywhere, Anytime Learning:
                    </div>
                    <p className="text-xs max-w-[16rem]">
                      Access courses seamlessly across devices.
                    </p>
                  </div>
                  <div className="pl-5 py-2 lg:py-4  flex flex-col justify-center rounded-full text-[#10124E] bg-gradient-to-r from-[#c1e7ff]  to-[#CEEEE900] to-50%">
                    <div className="lg:text-lg xl:text-xl">
                      Personalized Learning Paths:
                    </div>
                    <p className="text-xs max-w-[16rem]">
                      Tailored journeys to match every learner's goals{" "}
                    </p>
                  </div>
                  <div className="pl-5 py-2 lg:py-4  flex flex-col justify-center rounded-full text-[#10124E] bg-gradient-to-r from-[#B5E0FA]  to-[#CEEEE900] to-60%">
                    <div className="lg:text-lg xl:text-xl">
                      Real-Time Analytics:
                    </div>
                    <p className="text-xs max-w-[16rem]">
                      Gain actionable insights into training effectiveness.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 my-10 lg:p-16 xl:px-[5.7rem] bg-[#F4F4F4]">
          <FeaturesBento />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-[5.7rem]">
          <WhyChoose />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 ">
          <LearningTestimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback from your teammates."
          />
        </section>
      </BlurFade>

      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here */}
          <FindJobLayout
            title="Boost Your Team's Potential with Expert Corporate Training!"
            description="Looking for tailored training solutions to upskill your workforce? From leadership and domain expertise to soft skills and compliance, Dream Weavers offers industry-leading corporate training programs designed to elevate your organization's performance."
            buttonContent="Get Started Today!"
            buttonUrl="/training"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28 my-10">
          <MeetTeam
            title="Meet the Dream LMS' Powerhouses!"
            description="There are many variations of passages of Lorem Ipsum available, but the majority have suffered in some form, by injected humour"
            teamMembers={teamMembers}
            leftMember={leftMember}
            hideDescription={true}
          />
        </section>
      </BlurFade>
      <section>
        <Social images={socialImages} socialLinks={socialLinks} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
    </div>
  );
};

export default LearningPage;
